// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","actions":"Footer_actions__XC+Nt"};